export default "__VITE_ASSET__4bzLQN83kEjQjEZhq2gUow__"